function getScrollableParent(element: HTMLElement): HTMLElement | null {
  let parent = element.parentElement

  while (parent) {
    const { overflow, overflowY } = window.getComputedStyle(parent)
    const isScrollable =
      (overflow === 'auto' ||
        overflow === 'scroll' ||
        overflowY === 'auto' ||
        overflowY === 'scroll') &&
      parent.scrollHeight > parent.clientHeight

    if (isScrollable) {
      return parent
    }

    parent = parent.parentElement
  }

  return null
}

export function scrollIntoView(index: number, element: HTMLElement) {
  const scrollableParent = getScrollableParent(element)

  if (!scrollableParent) {
    return
  }

  if (index === 0) {
    scrollableParent.scrollTop = 0

    return
  }

  const { offsetTop, clientHeight } = element

  const { scrollTop, clientHeight: parentHeight } = scrollableParent

  if (offsetTop < scrollTop) {
    scrollableParent.scrollTop = offsetTop
  } else if (offsetTop + clientHeight > scrollTop + parentHeight) {
    scrollableParent.scrollTop = offsetTop - parentHeight + clientHeight
  }
}
